export default __webpack_public_path__ + "static/media/exams_icon.9a5fd66b.svg";